import axios from "axios";
import jwtDefaultConfig from "../@core/auth/jwt/jwtDefaultConfig";

const axiosCustom = axios.create();
axiosCustom.interceptors.request.use(
  (config) => {
    // ** Get token from localStorage
    const accessToken = getToken();

    // ** If token is present add it to request's Authorization Header
    if (accessToken) {
      // ** eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `${jwtDefaultConfig.tokenType} ${accessToken}`;
      config.headers.idplataforma = 3;
      config.headers.idaplicativo = 1000001;
      config.headers.imei = 0;
      config.headers["x-token"] = accessToken;
      config.headers["x-path"] = window.location.pathname;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ** Add request/response interceptor
axiosCustom.interceptors.response.use(
  (response) => response,
  (error) => {
    // ** const { config, response: { status } } = error
    const { config, response } = error;

    //const configD = useJwt.jwtConfig;

    // ** if (status === 401) {
    if (response && response.status === 401) {
      localStorage.removeItem("userData");
      localStorage.removeItem("versionK");
      localStorage.removeItem(jwtDefaultConfig.storageTokenKeyName);
      localStorage.removeItem(jwtDefaultConfig.storageRefreshTokenKeyName);
      window.location.reload();

      return Promise.reject("No access token set.");
    }
    return Promise.reject(error);
  }
);

const getToken = () => {
  return localStorage.getItem(jwtDefaultConfig.storageTokenKeyName);
};

export { axiosCustom, getToken };
